import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="phone-number-search"
export default class extends Controller {
  static targets = ["form", "input", "submit", "spinner", "results"]

  connect() {
    console.log("Phone number search controller connected")
  }

  showLoading() {
    // Show spinner, hide results
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden")
    }
    if (this.hasResultsTarget) {
      this.resultsTarget.classList.add("hidden")
    }
  }

  hideLoading() {
    // Hide spinner, show results
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden")
    }
    if (this.hasResultsTarget) {
      this.resultsTarget.classList.remove("hidden")
    }
  }
}
